import type { QueryClient } from "react-query";

import { GET_TARGET_MARKERS } from "@constants/reactQueryKeys";

/**
 * Invalidates the markers query of every given target, once each.
 *
 * A marker can be shared across targets, so a change made from one target's
 * chart also changes what other charts show — including targets a marker was
 * just removed from, which only the caller knows about.
 *
 * @param queryClient - The react-query client
 * @param targetIds   - Targets whose markers changed; ids that aren't positive
 *                      integers (null, undefined, NaN, 0) are ignored
 */
export function invalidateTargetMarkers(
  queryClient: QueryClient,
  targetIds: Array<number | null | undefined>
) {
  const isTargetId = (id: number | null | undefined): id is number =>
    Number.isInteger(id) && (id as number) > 0;

  new Set(targetIds.filter(isTargetId)).forEach((targetId) => {
    queryClient.invalidateQueries([GET_TARGET_MARKERS, targetId]);
  });
}
